export class Loader {
    constructor(elementId = 'loadingStatus') {
        this.element = document.getElementById(elementId);
        if (!this.element) {
            throw new Error(`Loader: Element with id '${elementId}' not found.`);
        }
    }

    show(message = 'Loading...') {
        
        this.element.textContent = message;
        this.element.style.display = 'block';
    }

    hide() {
        this.element.style.display = 'none';
    }

    setMessage(message) {
       
        this.element.textContent = message;
         this.element.style.display = 'block';
    }
}
